import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';

import { withAccount } from '../../../components/AccountContext';
import SurveyRespondentDetailComponent from './components/SurveyRespondentDetailComponent';
import SurveyRespondentDetailQuery from './SurveyRespondentDetailQuery';
import { Loading } from '../../../components/Loading';
import { growlActionSuccess, growlErrors } from '../../../utils/NotificationUtil';
import {
  sendSurveyRespondentEmailInvite,
  sendSurveyRespondentEmailRemind,
  previewSurvey,
} from '../../../services/apps/SurveyService';
import { withGrowl } from '../../../components/GrowlNotifications';
import { intlShape, growlShape } from '../../../components/prop-types';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

const mapStateToProps = (state) => {
  const { availableTranslations } = state.i18n;
  return {
    availableTranslations,
  };
};

class SurveyRespondentDetailComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailSending: false,
    };
    this.sendInviteEmail = this.sendInviteEmail.bind(this);
    this.sendRemindingEmail = this.sendRemindingEmail.bind(this);
    this.previewSurvey = this.previewSurvey.bind(this);
  }

  sendInviteEmail() {
    const {
      currentAccount, intl, SurveyRespondentDetail, growl,
    } = this.props;
    const { formatMessage } = intl;
    const { surveyRespondent } = SurveyRespondentDetail;

    if (surveyRespondent) {
      this.setState({ isEmailSending: true });
      sendSurveyRespondentEmailInvite({
        surveyRespondentId: surveyRespondent.id,
        accountId: currentAccount,
      })
        .then(() => {
          this.setState({ isEmailSending: false });
          growlActionSuccess(growl, formatMessage(messages.successNoti));
        })
        .catch((errors) => {
          this.setState({ isEmailSending: false });
          growlErrors(growl, errors);
        });
    }
  }

  sendRemindingEmail() {
    const {
      currentAccount, SurveyRespondentDetail, intl, growl,
    } = this.props;
    const { formatMessage } = intl;
    const { surveyRespondent } = SurveyRespondentDetail;

    if (surveyRespondent) {
      this.setState({ isEmailSending: true });
      sendSurveyRespondentEmailRemind({
        surveyRespondentId: surveyRespondent.id,
        accountId: currentAccount,
      })
        .then(() => {
          this.setState({ isEmailSending: false });
          growlActionSuccess(growl, formatMessage(messages.successNoti));
        })
        .catch((errors) => {
          this.setState({ isEmailSending: false });
          growlErrors(growl, errors);
        });
    }
  }

  async previewSurvey() {
    const { SurveyRespondentDetail, currentAccount, growl } = this.props;
    const { surveyRespondent } = SurveyRespondentDetail;

    try {
      const result = await previewSurvey({
        surveyRespondentId: surveyRespondent.id,
        accountId: currentAccount,
      });
      window.open(result.getSurveyUrl, '_blank');
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  render() {
    const { SurveyRespondentDetail, currentAccount, availableTranslations } = this.props;
    const { loading, account } = SurveyRespondentDetail;
    if (loading || !account || !account.surveyRespondent) {
      return <Loading />;
    }
    const { surveyRespondent } = SurveyRespondentDetail.account;
    const { isEmailSending } = this.state;
    return (
      <SurveyRespondentDetailComponent
        surveyRespondent={surveyRespondent}
        currentAccount={currentAccount}
        sendInviteEmail={this.sendInviteEmail}
        sendRemindingEmail={this.sendRemindingEmail}
        previewSurvey={this.previewSurvey}
        availableTranslations={availableTranslations}
        isEmailSending={isEmailSending}
      />
    );
  }
}
SurveyRespondentDetailComp.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  growl: growlShape.isRequired,
  SurveyRespondentDetail: PropTypes.objectOf(PropTypes.any).isRequired,
  availableTranslations: PropTypes.arrayOf(PropTypes.any).isRequired,
};

const SurveyRespondentDetailSQL = withGrowl(SurveyRespondentDetailQuery(SurveyRespondentDetailComp));

export default connect(
  mapStateToProps,
)(injectIntl(withAccount(SurveyRespondentDetailSQL)));
